export enum BaseGetter {
  ActiveLayout = 'base.activeLayout',
  LayoutTypes = 'base.layoutTypes',
  IsLayoutSwitchVisible = 'base.isLayoutSwitchVisible',
  Country = 'base.country',
  Locale = 'base.locale',
  IsLoading = 'base.isLoading',
  Errors = 'base.errors',
  Warnings = 'base.warnings',
}

export enum FilterGetter {
  SideBarVisibility = 'filter.sideBarVisibility',
  DisplayFilters = 'filter.displayFilters',
  ActiveSearchContext = 'filter.activeSearchContext',
  SearchContexts = 'filter.searchContexts',
  SearchContextsData = 'filter.searchContextsData',
  Filters = 'filter.filters',
  AppliedFilterOptions = 'filter.appliedFilterOptions',
  AppliedFilterOptionsSerialized = 'filter.appliedFilterOptionsSerialized',
}

export enum LocalizationGetter {
  Locale = 'localization.locale',
}

export enum SearchGetter {
  ActiveSearchContextData = 'search.activeSearchContextData',
  SearchResults = 'search.searchResults',
  CategoriesSearchResults = 'search.categoriesSearchResults',
  ExternalSearchResults = 'search.externalSearchResults',
  ProductSearchResults = 'search.productSearchResults',
  SearchSuggestions = 'search.searchSuggestions',
  OriginalSearch = 'search.originalSearch',
  TotalNumberOfResults = 'search.totalNumberOfResults',
  CategoriesTotalNumberOfResults = 'search.categoriesTotalNumberOfResults',
  ExternalTotalNumberOfResults = 'search.externalTotalNumberOfResults',
  ProductTotalNumberOfResults = 'search.productTotalNumberOfResults',
  TotalNumberOfSuggestedResults = 'search.totalNumberOfSuggestedResults',
  IsLoading = 'search.isLoading',
  SearchTerm = 'search.searchTerm',
  StrictSearch = 'search.strictSearch',
  CategoriesIsLoading = 'search.categoriesIsLoading',
  ProductsIsLoading = 'search.productsIsLoading',
  ExternalIsLoading = 'search.externalIsLoading',
}
